<template>
    <div class="text-center ">
        <v-modal-contents ref="modal_contents_agree">

            <template v-slot:close>
                <!--        убираем close-->
                <div></div>
            </template>

            <template v-slot:title>

                <div class="terms_of_use__title ">
                    <div class="h2_title">Условия использования персональных данных</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <div v-html="terms"></div>
                    <div class="mt-30">
                        <button class="px-30 btn-red"
                                @click="$refs.modal_contents_agree.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>

        <v-dialog content-class="dialog_custom dialog_call" v-model="dialog" width="516" relative persistent>
            <v-card>
                <v-card-text>
                    <v-form ref="form" @submit.prevent="" action="#" class="" v-model="valid" lazy-validation>

                        <section class="call">
                            <div class="call__header">
                                <h2 class="call__title">
                                    Заказать звонок
                                </h2>

                                <button class="call__close" @click="dialog = false">
                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                                d="M17.9991 15.8801L25.4241 8.45508L27.5451 10.5761L20.1201 18.0011L27.5451 25.4261L25.4241 27.5471L17.9991 20.1221L10.5741 27.5471L8.45312 25.4261L15.8781 18.0011L8.45312 10.5761L10.5741 8.45508L17.9991 15.8801Z"
                                                fill="#52525B"/>
                                    </svg>
                                </button>
                            </div>

                            <div class="call__inner">
                                <div class="call__form">
                                    <label for="name" class="call__label">
                                        <v-text-field
                                                v-model="name"
                                                :rules="nameRulesRu"
                                                required
                                                id="name"
                                                class="call__input"
                                        >
                                            <template v-slot:label>
                                                ФИО *
                                            </template>
                                        </v-text-field>
                                    </label>

                                    <label for="tel" class="call__label">
                                        <v-text-field
                                                v-model="tel_input"
                                                :rules="tel_inputRulesRu"
                                                required
                                                id="tel"
                                                class="call__input"
                                                oninput="this.value = this.value.replace(/[^\d+]/g,'');"
                                        >
                                            <template v-slot:label>
                                                Телефон *
                                            </template>
                                        </v-text-field>
                                    </label>
                                </div>

                                <!-- SmartCaptcha -->
                                <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                                     class="w-100 mt-30"></div>

                                <div class="form_upload__item">
                                    <v-checkbox
                                            v-model="checkbox"
                                            :rules="[(v) => !!v || 'Это обязательный пункт']"
                                            required
                                            color="red"
                                    >
                                        <template v-slot:label>
                                            <div class="customLabelForm">
                                                Я выражаю согласие с <a href="javascript:void(0);" target="_blank"
                                                                        @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                                                использования</a> моих персональных данных для обработки данного
                                                обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,
                                                Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,
                                                этаж 2), я ознакомлен и выражаю согласие с
                                                <a :href="policy" @click="linkOpen(policy)"
                                                   class="position-relative zi-1">Политикой конфиденциальности</a> и
                                                <a :href="agreement" @click="linkOpen(agreement)"
                                                   class="position-relative zi-1">Пользовательским соглашением.</a>
                                            </div>
                                        </template>
                                    </v-checkbox>
                                    <v-checkbox
                                            v-model="consentToInform"

                                            color="red"
                                            class="mt-0"
                                    >
                                        <template v-slot:label>
                                            <div class="customLabelForm">
                                                Я выражаю согласие на информирование меня о продуктах, акциях,
                                                выгодных предложениях, новостях ООО «Компания Нова Ролл» (ИНН
                                                5038050970, адрес: 141206, Московская область, г. Пушкино,
                                                Кудринское шоссе, д. 2а, стр. 5, этаж 2) и партнеров.
                                            </div>
                                        </template>
                                    </v-checkbox>


                                </div>
                                <div class="call__box">
                                    <button :disabled="!valid" class="call__btn btn-red"
                                            @click="validate">
                                        Отправить
                                    </button>
                                </div>
                            </div>
                        </section>

                    </v-form>

                </v-card-text>

            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import VModalContents from "./modal_contents";

export default {
    components: {
        VModalContents: VModalContents,
    },
    props: {
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
    },

    data() {
        return {
            checkbox: false,
            consentToInform: false,

            captchaPassed: false,

            dialog: false,
            valid: true,

            name: "",
            nameRulesRu: [
                (v) => !!v || "Обязательное поле",
            ],
            tel_input: "",
            tel_inputRulesRu: [
                (v) => !!v || "Обязательное поле", ,
                (v) => /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(v) || "Неккоректный телефон",
            ],

        };
    },
    methods: {
        linkOpen(url) {
            window.open(url, '_blank');
        },
        // Captcha
        initCaptcha() {
            window.smartCaptcha.render('captcha-container', {
                sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
                callback: this.onCaptchaSuccess,
            });
        },
        onCaptchaSuccess(token) {
            this.captchaPassed = true;
            this.form.captchaToken = token;
        },
        // Captcha end

        validate() {
            if (!this.$refs.form.validate()) return false;
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }

            var VueObject = this;

            let newTel = VueObject.tel_input;
            if (newTel[0] === '8') {
                newTel = newTel.slice(1); // если первая цифра 8, удаляем её
            }
            $.ajax({
                "type": "POST",
                "url": "/ajax/contacts-call.php",
                "data": {
                    "ajaxPost": "Y",
                    "name": VueObject.name,
                    "phone": newTel,
                },
                "success": function (res) {
                    console.log(res);
                    VueObject.dialog = false;
                    $(".text_result_new .send__title").text("Заявка отправлена");
                    $(".text_result_new .send__subtitle").text("Мы перезвоним Вам в рабочее время");
                    $(".text_result_new").slideDown(300);
                    VueObject.reset();
                },
                "error": function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                }
            });
        },
        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },
        modal_open(event) {

            if (this.dialog) {
                this.dialog = false;
            } else {
                this.dialog = true;
                this.$nextTick(function () {
                    this.initCaptcha();
                });
            }
        },
    },

    watch: {
        captchaPassed() {
            // this.sendForm();
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
        },
    }
};
</script>


<style lang="scss">
.dialog_custom .v-messages {
  min-height: 0;
}

.v-application .error--text {
  border-color: #ff5252 !important;
}

.v-dialog.dialog_custom > .v-card > .v-card__text {
  padding: 0 !important;
}

body .dialog_custom.v-dialog {
  width: 516px !important;
  padding-right: 0;

  @media (max-width: 600px) {
    width: 90% !important;
    margin: 0;
  }

  & .v-sheet.v-card {
    height: auto !important;
  }
}

.dialog_custom {

  & .v-text-field__details {
    text-align: left;
    position: absolute;
    bottom: 2px;
    left: 15px;
    width: max-content;
    padding: 0 !important;
  }

  & .v-input__slot {
    margin: 0 !important;

    &::before {
      display: none !important;
    }

    &::after {
      display: none !important;
    }
  }

  & .v-text-field .v-label {
    background: #ffffff;
    height: 22px;
    width: 100%;
    color: #404040;
  }

  & .call__label .primary--text {
    color: #656565 !important;
    caret-color: #656565 !important;
  }

  & .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none !important;
  }

  & .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0 !important;
  }


  & .call {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #f2f2f2;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);

    &__input {
      border: 1px solid rgba(226, 226, 226, 1);
      box-shadow: none !important;
      border-radius: 10px;
      padding: 18px 15px !important;
      width: 100%;
      font-family: 'MuseoSansCyrl-500';
      font-weight: 400;
      font-style: 500;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0px;
      color: rgba(101, 101, 101, 1);
      margin-bottom: 0;
    }

    &__inner {
      padding: 0 30px 30px 30px;
      background: #FFFFFF;
      border-radius: 19px;
      position: relative;
      max-width: 516px;
      max-height: 650px;
      overflow-y: auto;

      @media (max-height: 900px) {
        max-height: 60vh;
        max-width: calc(100% - 60px);
        padding: 0 0 30px 0;
        overflow-x: hidden;
      }
    }

    &__close {
      background: none;
      cursor: pointer;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      padding: 30px;
      width: 100%;
    }

    &__textarea {
      resize: none;
      height: 160px;
      border-radius: 15px;
      outline: none;
      font-size: 16px;
      font-family: 'Roboto', sans-serif;
      line-height: 100%;
      font-weight: 400;
      color: #282828;
    }

    &__mess {
      position: absolute;
      top: -8px;
      background: #FFFFFF;
      color: #F94237;
      padding: 0 7px;
    }

    &__title {
      font-family: 'MuseoSansCyrl-500';
      font-weight: 400;
      font-style: 500;
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 0px;
      margin-bottom: 0;
      color: rgba(33, 36, 36, 1);

      @media (max-width: 600px) {
        font-size: 26px;
        line-height: 32px;
      }

      @media (max-width: 375px) {
        font-size: 26px;
        line-height: 32px;
      }
    }

    &__form {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: start;
      gap: 20px;
    }

    &__label {
      position: relative;
      width: 100%;
      margin-bottom: 0;
    }

    &__box {
      display: flex;
      align-items: center;
      gap: 36px;
      margin-top: 25px;

      @media(max-width: 520px) {
        flex-direction: column;
        align-items: start;
      }
    }

    &__text {
      font-size: 14px;
      line-height: 18px;
      color: #9C9C9C;
    }

    &__btn:not([disabled="disabled"]) {
      background: #f94237;
      color: #fff;
    }

    &__btn {
      background: rgba(226, 226, 226, 1);
      border-radius: 42px;
      padding: 16px;
      font-family: 'MuseoSansCyrl-500';
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      width: 100%;
    }
  }

}


.send {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99;

  &__inner {
    padding: 32px 24px;
    background: #FFFFFF;
    border-radius: 15px;
    position: relative;
    max-width: 380px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media(max-width: 520px) {
      height: 100vh;
      max-width: none;
      width: 100vw;
      border-radius: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  &__close {
    background: none;
    cursor: pointer;
  }

  &__icon {
    margin-bottom: 20px;
  }

  &__title {
    font-family: 'MuseoSansCyrl-500', sans-serif;
    font-weight: 500;
    font-size: 28px;
    margin-bottom: 24px;
  }

  &__subtitle {
    font-size: 16px;
    margin-bottom: 32px;
    text-align: center;
  }

  &__btn {
    background: #F94237;
    border-radius: 42px;
    padding: 16px;
    text-align: center;
    font-family: 'MuseoSansCyrl-500', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    min-width: 115px;

    @media(max-width: 520px) {
      position: absolute;
      bottom: 32px;
      width: calc(100% - 48px);
    }
  }
}

</style>
